export const updateConditionsRequestMapping = async (inputData) => {
	const [
		additionalConditionsLife,
		additionalConditionsCriticalIllness,
		additionalConditionsUnableToWork,
	] = inputData;

	const response = {
		life: {
			loading: additionalConditionsLife?.additionalConditionsLife?.loading || 0,
			exclusionCodes:
				additionalConditionsLife?.additionalConditionsLife?.exclusionCodes ||
				[],
		},
		criticalIllness: {
			loading:
				additionalConditionsCriticalIllness?.additionalConditionsCriticalIllness
					?.loading || 0,
			exclusionCodes:
				additionalConditionsCriticalIllness?.additionalConditionsCriticalIllness
					?.exclusionCodes || [],
		},
		unableToWork: {
			loading:
				additionalConditionsUnableToWork?.additionalConditionsUnableToWork
					?.loading,
			exclusionCodes:
				additionalConditionsUnableToWork?.additionalConditionsUnableToWork
					?.exclusionCodes,
		},
	};

	return response;
};

//* Example of the return data that we are mapping to
//* {
//*     "life": {
//*         "loading": 10,
//*         "exclusionCodes": [
//*             "MSLPAP"
//*         ]
//*     },
//*     "criticalIllness": {
//*         "loading": 20,
//*         "exclusionCodes": [
//*             "MUTPRO",
//*             "ASCUBA"
//*         ]
//*     },
//*     "unableToWork": {
//*         "loading": 30,
//*         "exclusionCodes": []
//*     }
//* }

//* {
//*     "criticalIllness": {
//*         "loading": 0,
//*         "exclusionCodes": []
//*     }
//* }
